import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useScene } from '../../context/SceneContext';

/**
 * SceneHUD — a JetBrains-Mono technical annotation strip showing the active
 * scene id, mutation count, and a regenerate hint. Floats top-right.
 */
export default function SceneHUD() {
  const { scene, sceneIndex, scenes, mutationCount } = useScene();

  return (
    <div
      className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40 pointer-events-none select-none"
      data-testid="scene-hud"
    >
      <div className="font-mono text-[10px] sm:text-[11px] tracking-[0.2em] uppercase text-white/60 leading-tight space-y-1 text-right">
        <div className="flex items-center gap-2 justify-end">
          <span style={{ color: 'var(--scene-accent)' }}>
            FRAME {String(sceneIndex + 1).padStart(2, '0')} / {String(scenes.length).padStart(2, '0')}
          </span>
          <span
            className="w-1.5 h-1.5 rounded-full"
            style={{
              background: 'var(--scene-accent)',
              boxShadow: '0 0 8px var(--scene-accent)',
            }}
          />
        </div>
        <AnimatePresence mode="wait">
          <motion.div
            key={scene.id}
            initial={{ opacity: 0, y: -4 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 4 }}
            transition={{ duration: 0.35 }}
            className="text-white/45"
          >
            {scene.id.replace(/-/g, ' / ')}
          </motion.div>
        </AnimatePresence>
        <div className="text-white/22 hidden sm:block">
          MUTATIONS · {String(mutationCount).padStart(3, '0')}
        </div>
        <div className="text-white/22 hidden sm:block">
          CLICK CANVAS · REGENERATE
        </div>
      </div>
    </div>
  );
}
